import script from "./billList.vue?vue&type=script&setup=true&lang=js"
export * from "./billList.vue?vue&type=script&setup=true&lang=js"

import "./billList.vue?vue&type=style&index=0&id=bbf9c272&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbf9c272"]])

export default __exports__